<template>
  <div style="height: 100%">
    <el-row v-if="gisStatus==true" style="margin-bottom: 0px">
    <el-col :span="24">
      <div id="GisView" style="width: calc(100% - 16px);height: calc(100% - 10px);margin-left: 8px;margin-right: 8px;">
        <GisView/>
      </div>
    </el-col>
  </el-row>
    <el-row style="height: 100%;margin-bottom: 0px;">
    <el-col :span="24">
      <div id="DataView" style="width: calc(100% - 16px);height: calc(100% - 10px);margin-top: 5px;margin-left: 8px;margin-right: 8px;">
        <router-view/>
      </div>
    </el-col>
  </el-row>
  </div>
</template>

<script>
import GisView from "@/components/GisView";

export default {
  name: 'MainWindow',
  components: {
    GisView,
  },
  props: ["gisStatus"],
}
</script>
